"use client";

import React, { ReactNode } from "react";
import { cn } from "../lib/utils";
import { Loading } from "./Loading";

const buttonVariants = {
  primary: "bg-blue-500 text-neutral-500 hover:bg-blue-500/80",
  secondary: "bg-gray-500 text-neutral-500 hover:bg-gray-600",
  outline: "bg-white text-blue-500 border border-blue-500 hover:bg-blue-50",
  danger: "bg-red-600 text-white hover:bg-red-600/80",
} as const;

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: keyof typeof buttonVariants;
  loading?: boolean;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  fullWidth?: boolean;
}

const Button = ({
  className,
  variant = "primary",
  loading = false,
  leftIcon,
  rightIcon,
  fullWidth = false,
  children,
  disabled,
  ...props
}: ButtonProps) => {
  return (
    <button
      disabled={disabled || loading}
      className={cn(
        "rounded-md px-3 py-2 text-xs md:text-sm font-semibold shadow-xs flex flex-row justify-center items-center",
        buttonVariants[variant],
        fullWidth && "w-full",
        disabled && "opacity-40 cursor-not-allowed",
        className,
      )}
      {...props}
    >
      {loading && <Loading />}
      {leftIcon && !loading && <span className="mr-1 mt-1">{leftIcon}</span>}
      {children}
      {rightIcon && <span className="ml-2">{rightIcon}</span>}
    </button>
  );
};

export { Button, type ButtonProps };
